import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../lib/api';

export const fetchChatLogs = createAsyncThunk(
  'logs/fetch',
  async ({ filters = {}, page = 1 }) => {
    const params = new URLSearchParams({ ...filters, page }).toString();
    const res = await api.get(`/chatlogs/?${params}`);
    return res.data;
  }
);

export const fetchFeedbackStats = createAsyncThunk(
  'logs/fetchFeedbackStats',
  async () => {
    const res = await api.get('/chatlogs/feedback-counts/');
    return res.data;
  }
);

export const fetchEmailStats = createAsyncThunk(
  'logs/fetchStats',
  async () => {
    const res = await api.get('/chatlogs/stats/');
    return res.data;
  }
);

export const submitChatFeedback = createAsyncThunk(
  'logs/submitFeedback',
  async ({ chat_id, value, widget_token }, { rejectWithValue }) => {
    try {
      const payload = { chat_id, value };
      if (widget_token) payload.widget_token = widget_token;
      const res = await api.post('/chatlogs/feedback/', payload, { suppressToast: true });
      return res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.error || (e?.response ? 'Failed to submit feedback.' : 'Network error: unable to submit feedback.')
      );
    }
  }
);

const logSlice = createSlice({
  name: 'logs',
  initialState: {
    list: [],
    stats: [],
    feedbackCounts: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChatLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results || action.payload;
        state.totalPages = Math.ceil((action.payload.count || action.payload.length || 0) / 10);
      })
      .addCase(fetchEmailStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      })
      .addCase(fetchFeedbackStats.fulfilled, (state, action) => {
        state.feedbackCounts = action.payload;
      })
      .addCase(fetchChatLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default logSlice.reducer;
